var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-info",attrs:{"href":_vm.source,"target":"_blank"}},[_vm._v("Videos tutoriales")])
}
var staticRenderFns = []

export { render, staticRenderFns }